module.exports = __webpack_public_path__ + "static/media/HomeTab6.5f8e5c39.jpg";